module.exports = __webpack_public_path__ + "src/assets/img/m5.b68a3eb4.jpg";